var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-wrapper"},[_c('iframe',{staticClass:"kakao-iframe",attrs:{"src":"/kakaomap.html","frameborder":"0","scrolling":"no"}})])
}]

export { render, staticRenderFns }